import { AppSidebar } from "@shared/layouts/app-sidebar";
import {
  SidebarInset,
  SidebarProvider,
  SidebarTrigger,
} from "@shared/components/ui/sidebar";
import { useTranslation } from "react-i18next";
import { getDirection } from "@shared/utils/rtl";
import Navbar from "@shared/layouts/Navbar";
import Footer from "@shared/layouts/Footer";

export default function RootLayout({ children }) {
  const { i18n } = useTranslation();

  const direction = getDirection(i18n.language);

  return (
    <SidebarProvider>
      <AppSidebar
        side={direction === "rtl" ? "right" : "left"}
        collapsible="offcanvas"
        className="shadow-sm border-r"
      />
      <SidebarInset>
        <div className="flex flex-col min-h-screen bg-gradient-to-br from-background to-muted/20">
          {/* Header/Navigation with glass morphism effect */}
          <div className="sticky top-0 z-50 backdrop-blur-md bg-background/80 border-b shadow-sm">
            <Navbar SidebarTrigger={SidebarTrigger} />
          </div>

          {/* Important Announcement Banner */}
          <div className="mb-2"></div>
          <div
            className="rounded-md border-l-4 border-blue-500 bg-blue-50 p-4 text-blue-900 text-sm"
            dir="rtl"
          >
            <strong>إعلان مهم 🚀</strong>
            <div>
              نحن ننتقل إلى منصة جديدة!
              <br />
              <br />
              يرجى زيارة المنصة الجديدة على:{" "}
              <a
                href="https://client.skypostal.ma/register"
                target="_blank"
                rel="noopener noreferrer"
                className="font-bold underline hover:text-blue-700"
              >
                https://client.skypostal.ma/register
              </a>
              <br />
              <br />
              قم بإنشاء حساب جديد على المنصة الجديدة للحصول على أفضل تجربة وميزات محسّنة.
            </div>
          </div>

          {/* Profile Alert Banner
          {!auth.user?.banking && (
            <div className="relative z-40">
              <div className="mx-4 mt-4">
                <AlertCompleteProfile />
              </div>
            </div>
          )} */}

          {/* Main Content Container */}
          <main className="flex-1 flex flex-col min-h-0 p-2 md:p-4 lg:p-6">
            {/* Content Wrapper with improved spacing and max-width */}
            <div className="flex-1 w-full max-w-screen-2xl mx-auto">
              <div className="bg-background rounded-2xl shadow-sm border border-border/50 overflow-hidden h-full">
                {/* Inner content area with proper padding */}
                <div className="h-full p-2 md:p-4 lg:p-6 overflow-y-auto scrollbar-hide">
                  <div className="space-y-6">{children}</div>
                </div>
              </div>
            </div>
          </main>

          {/* Footer with improved spacing */}
          <div className="mt-auto">
            <Footer />
          </div>
        </div>
      </SidebarInset>
    </SidebarProvider>
  );
}
